import { defineComponent, h, PropType } from '@vue/composition-api';

import {
  FieldErrors,
  IWorkflowFormFieldNode,
  IWorkflowFormFieldNodeData,
  WorkflowFormField,
  WorkflowFormFieldNode
} from '@/models';
import { ComputationNodeSubtype } from '@/models/computation';

import Validatable from '@/mixins/validatable';
import BindsAttrs from '@/mixins/binds-attrs';

import { ComputationExpressionTreeContainer } from '../../common/computation/ComputationExpressionTreeContainer';
import WorkflowFormBuilderFieldNodeOperandNode from './WorkflowFormBuilderFieldNodeOperandNode.vue';
import WorkflowFormBuilderFieldNodeOperatorNode from './WorkflowFormBuilderFieldNodeOperatorNode.vue';

export default defineComponent({
  name: 'WorkflowFormBuilderComputationBuilder',

  props: {
    value: {
      required: false,
      type: Array as PropType<IWorkflowFormFieldNode[]>,
      default: () => []
    },
    fieldErrors: {
      required: false,
      type: Array as PropType<FieldErrors[]>,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  mixins: [Validatable, BindsAttrs],

  setup(props, { emit }) {
    return () => {
      return h(
        ComputationExpressionTreeContainer<
          IWorkflowFormFieldNode,
          IWorkflowFormFieldNodeData
        >(),
        {
          props: {
            value: props.value,
            disabled: props.disabled,
            fieldErrors: props.fieldErrors,
            disableUnaryExpression: true,
            disableBinaryExpression: true,
            nodeClass: WorkflowFormFieldNode,
            maxTreeDepthLevel: WorkflowFormField.MAX_EXPRESSION_TREE_DEPTH,
            defaultOperandSubtype: ComputationNodeSubtype.Variable
          },
          on: {
            input: (nodes: IWorkflowFormFieldNode[]) => emit('input', nodes)
          },
          scopedSlots: {
            'operator-node': nodeVData => {
              return h(WorkflowFormBuilderFieldNodeOperatorNode, nodeVData);
            },
            'operand-node': nodeVData => {
              return h(WorkflowFormBuilderFieldNodeOperandNode, nodeVData);
            }
          }
        }
      );
    };
  }
});
